import { FC } from 'react';
import Button from '@amzn/awsui-components-core/button';
import SpaceBetween from '@amzn/awsui-components-core/space-between';

interface CampaignCardActionsProps {
  createLabel: string;
  viewLabel: string;
  onCreateClick: () => void;
  onViewClick: () => void;
}

const CampaignCardActions: FC<CampaignCardActionsProps> = ({
  createLabel,
  viewLabel,
  onCreateClick,
  onViewClick,
}) => {
  return (
    <SpaceBetween direction="horizontal" size="xs">
      <Button variant="primary" onClick={onCreateClick}>
        {createLabel}
      </Button>
      <Button variant="normal" onClick={onViewClick}>
        {viewLabel}
      </Button>
    </SpaceBetween>
  );
};

export default CampaignCardActions;

